import React__default from 'react';
import styled, { css } from 'styled-components';
import { i as isMobile } from '../theme/style-mixins/isMobile/isMobile-CGsYoba7.js';
import { T as TaktIdProvider } from '../TaktIdContext/TaktIdContext-C6vdL-6Z.js';
import { c as createStormTaktId } from '../TaktIdContext/TaktIdContext.utils-B0CzqlN8.js';

const StyledList = /*#__PURE__*/styled('ul').withConfig({
  componentId: "sc-storm-ui-40026394__sc-cixak9-0"
})(["font:", ";color:", ";margin:0;margin-inline-start:", ";padding:0;display:block;", ""], ({
  theme
}) => theme.font.text.base.default, ({
  theme
}) => theme.text.color.default, ({
  theme
}) => theme.list.marginInlineStart, isMobile(css(["font:", ";"], ({
  theme
}) => theme.font.text.base.mobile)));
const UnorderedList = ({
  children,
  taktId,
  taktValue,
  ...rest
}) => /*#__PURE__*/React__default.createElement(TaktIdProvider, {
  taktId: taktId,
  taktValue: taktValue,
  fallbackId: createStormTaktId('unordered-list')
}, /*#__PURE__*/React__default.createElement(StyledList, rest, children));

export { UnorderedList as U };
//# sourceMappingURL=UnorderedList-JkrYqsB4.js.map
